// 📁 src/services/diaryService.ts
import axios from 'axios';
import { config } from './config';
import apiClient from "./apiClient";

// const apiClient = axios.create({
//   baseURL: config.API_URL,
//   headers: { "Content-Type": "application/json" },
// });

export const diaryService = {
  getEntries: async (token: string, cursor: string | null = null, limit: number = 10) => {
    const response = await apiClient.get('/diary', {
      params: {
        cursor,
        limit,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  createEntry: async (
    token: string,
    data: {
      feeling: 'TERRIBLE' | 'BAD' | 'NEUTRAL' | 'GOOD' | 'GREAT';
      description?: string;
      audioUrl?: string;
    }
  ) => {
    const response = await apiClient.post('/diary/entry', data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  getEntriesByMonth: async (token: string, year: number, month: number) => {
    const response = await apiClient.get("/diary/month", {
      params: { year, month },
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },
  
};
